import { faTag } from '@fortawesome/pro-light-svg-icons';
import cuid from 'cuid';
import gql from 'graphql-tag';

const MetadataTopic = {
  searchFragment: gql`
      fragment searchMetadataTopic on MetadataTag {
        id
        name
        tagTitle
        tagDescription
        tagDisplayName
        tagType
        hierarchy
        createdAt
        updatedAt
        hasDerivedStandards
      }
    `,
  fullFragment: gql`
      fragment fullMetadataTopic on MetadataTag {
        id
        name
        tagTitle
        tagDescription
        tagDisplayName
        tagType
        hierarchy
        certicaId
        origin
        createdAt
        updatedAt
        hasDerivedStandards
      }
    `,
  defaults: (id, data = {}) => {
    const tagId = id || cuid();
    const tagTitle = data.newLabel || null;

    return {
      client: {
        id: tagId,
        __typename: 'MetadataTag',
        tagType: 'PUBLIC_TAG',
        name: tagTitle || 'MetadataTopic',
        tagTitle,
        tagDescription: null,
        tagDisplayName: null,
        hasDerivedStandards: false,
        hierarchy: [],
        certicaId: null,
        origin: 'HUMAN',
        createdAt: (new Date()).toISOString(),
        updatedAt: (new Date()).toISOString(),
        assignedCount: 0
      },
      server: {
        id,
        tagTitle
      }
    };
  },
  icon: faTag,
  typename: 'MetadataTopic',
  openInApp: false,
  forms: {},
  inputs: {
    topicTags: {
      input: 'select',
      name: 'metadataCerticaTopics',
      label: 'Certica Topics',
      isMulti: true,
      isAsync: true,
      isRelation: true,
      isMetadataService: true,
      type: 'MetadataTopic',
      tooltipText: 'Taxonomy tags to categorize content into broad categories or areas of focus within a subject area (ELA, SS, SCI, MATH) for discovery or organizational purposes.',
      tooltipFeaturesPowered: null,
      query: 'searchMetadataTopics',
      showDropdown: false,
      mapping: {
        label: 'tagTitle',
        value: 'id',
        type: 'tagType',
        path: 'hierarchy',
        hasDerivedStandards: 'hasDerivedStandards',
      }
    }
  },
};
export default MetadataTopic;
